/**
 * @generated SignedSource<<83857396063635b3e28e771ac5530626>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppContainerQuery$variables = Record<PropertyKey, never>;
export type AppContainerQuery$data = {
  readonly user: {
    readonly id: number | null | undefined;
    readonly properties: {
      readonly property: ReadonlyArray<{
        readonly name: string | null | undefined;
        readonly value: string | null | undefined;
      }> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"AppFragment">;
  } | null | undefined;
};
export type AppContainerQuery = {
  response: AppContainerQuery$data;
  variables: AppContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "userLocator",
    "value": "current"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Properties",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Property",
      "kind": "LinkedField",
      "name": "property",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppFragment"
          }
        ],
        "storageKey": "user(userLocator:\"current\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAvatars",
            "kind": "LinkedField",
            "name": "avatars",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize20",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize28",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize32",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize40",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize56",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize64",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize80",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          }
        ],
        "storageKey": "user(userLocator:\"current\")"
      }
    ]
  },
  "params": {
    "cacheID": "c1e49c9ada4ddf66ee36690c96cbb5ef",
    "id": null,
    "metadata": {},
    "name": "AppContainerQuery",
    "operationKind": "query",
    "text": "query AppContainerQuery {\n  user(userLocator: \"current\") {\n    id\n    properties {\n      property {\n        name\n        value\n      }\n    }\n    ...AppFragment\n    _id\n  }\n}\n\nfragment AllUserSelectFragment on User {\n  id\n  avatars {\n    urlToSize40\n  }\n  name\n  username\n}\n\nfragment AppFragment on User {\n  ...currentUserKeyFragment\n  ...AllUserSelectFragment\n}\n\nfragment AvatarFragment on User {\n  id\n  name\n  username\n  avatars {\n    urlToSize20\n    urlToSize28\n    urlToSize32\n    urlToSize40\n    urlToSize56\n    urlToSize64\n    urlToSize80\n  }\n}\n\nfragment HeaderUserFragment on User {\n  id\n  name\n  username\n  ...AvatarFragment\n}\n\nfragment currentUserKeyFragment on User {\n  ...useMyIdFragment\n  ...useMyUsernameFragment\n  ...useUserPropertyFragment\n  ...useMyProfileFragment\n  ...HeaderUserFragment\n  ...AllUserSelectFragment\n}\n\nfragment useMyIdFragment on User {\n  id\n}\n\nfragment useMyProfileFragment on User {\n  name\n  username\n  email\n}\n\nfragment useMyUsernameFragment on User {\n  username\n}\n\nfragment useUserPropertyFragment on User {\n  properties {\n    property {\n      name\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "42f15473721547a4d2e7e59a4d06138b";

export default node;
